import type { HeadingLevel } from "./types"

export const headingElements: { [N in HeadingLevel]: `h${N}` } = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6",
}
